import script from "./ClientStatisticChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientStatisticChart.vue?vue&type=script&setup=true&lang=js"

import "./ClientStatisticChart.vue?vue&type=style&index=0&id=b5c81344&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5c81344"]])

export default __exports__